import { Callout, FormGroup } from "@blueprintjs/core";
import type { ExtraFieldTypeHelp } from "@package/ui-gql/index-data-access";
import type { ServiceDataFormFieldBaseProps } from "./ServiceDataFormFieldEmpty";

type ServiceDataFormFieldHelpProps = ServiceDataFormFieldBaseProps & {
  field: ExtraFieldTypeHelp;
};

function ServiceDataFormFieldHelpContent({
  field,
}: ServiceDataFormFieldHelpProps) {
  return (
    <FormGroup>
      <Callout compact intent="none">
        {field.label}
      </Callout>
    </FormGroup>
  );
}

export function ServiceDataFormFieldHelp({
  field,
  onSourceChanged,
  data,
}: ServiceDataFormFieldBaseProps) {
  if (field.__typename === "ExtraFieldTypeHelp") {
    return (
      <ServiceDataFormFieldHelpContent
        field={field}
        data={data}
        onSourceChanged={onSourceChanged}
      />
    );
  }

  return null;
}
